/* ============================================================
   VIVĀRA — Editable section copy
   ------------------------------------------------------------
   Section copy that legal or brand may need to revise lives here,
   in one place, so it can be edited without touching layout.
   ============================================================ */
(function () {
  "本ポリシーはVIVĀRAで直接ご注文いただいた場合に適用され、お客様の法律上の権利を妨げるものではありません。";

  /* ---------- WHY LIQUID ----------------------------------------------
     Deliberately practical language only. "Most bioavailable", "more
     absorbable" and "supports detoxification" are withdrawn and held in
     js/claims.js; do not restore absorption or comparative-superiority
     claims without substantiation on file.
     -------------------------------------------------------------------- */
  window.VIVARA_WHY_LIQUID = {
    eyebrow: "リキッドである理由",
    headingLines: ["純度と力を、", "必要なときに。"],

    // Neutral temporary body copy — no absorption or superiority claim.
    body:
      "リキッドは、樹脂を一滴単位で量り、数秒で取れるかたちに保ちます——" +
      "すくう手間も、溶かす時間も、一日の中断もありません。",

    // Practical attributes only — nothing here asserts an effect.
    qualities: [
      { label: "一滴単位で\n量れる" },
      { label: "数秒で\n用意できる" },
      { label: "持ち運び\nやすい" },
      { label: "伝統と科学が\n出会う" }
    ],

    // Comparison remains live HTML (spec §12) with practical rows only.
    // Rows removed from the earlier draft pending substantiation:
    // "Absorption", "純度", "Potency" — comparative claims.
    comparison: {
      columns: ["リキッド", "その他の形状"],
      rows: [
        { label: "量りとれる", liquid: true, other: false },
        { label: "数秒で用意", liquid: true, other: false },
        { label: "混ぜる必要なし", liquid: true, other: false },
        { label: "旅にも", liquid: true, other: false },
        { label: "毎日続けやすい", liquid: true, other: false },
        { label: "まろやかな味", liquid: true, other: false }
      ],
      note: null
    }
  };

})();
